import { EndorsementKey, type EndorsementConfig } from '../../types';
import { selectCheckedEndorsements, selectCyberCoverageLimit } from '../../../../selectors/application';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.CyberCoverage,
  label: 'Cyber Insurance',
  description: 'Provides coverage against losses resulting from a cyber attack, security breach, and/or data loss.',
  recommended: true,
};

export const DEFAULT_LIMITS_OPTIONS = [
  {
    label: '$50,000 coverage form aggregate / $50,000 liability coverage / $25,000 first party coverage',
    value: '25000/50000',
  },
  {
    label: '$100,000 coverage form aggregate / $100,000 liability coverage / $50,000 first party coverage',
    value: '50000/100000',
  },
];

export const isCyberCoverageValid = (state: ReduxState) => {
  const isChecked = selectCheckedEndorsements(state).includes(EndorsementKey.CyberCoverage);
  if (!isChecked) return true;
  const limit = selectCyberCoverageLimit(state);
  return DEFAULT_LIMITS_OPTIONS.some((option) => option.value === limit);
};
